import { fun } from '@/lib/request';
import { api } from '@/lib/env';
import { WrapResponse } from '@/types';
import { useParams, useSearchParams } from "next/navigation";
import { useState, useEffect, Suspense } from "react";
import { useGlobalConfig } from '@/stores/appStore';
import Loading from '@/components/Loading';

function MobileSideContent() {
  const [url, setUrl] = useState('');
  const search = useSearchParams();
  const i = search.get('i');
  const { inviteCode = '' } = useParams() as { inviteCode: string; };

  const {
    value: config,
    fetch: fetch,
  } = useGlobalConfig().globalConfig;

  useEffect(() => {
    fetch();
  }, [fetch])

  const images = config?.pc?.mobileDetectImageUrls || [
    'https://oss.findinai.cn/storage/20250426/ecbfcadf05bd83ef032a2dac0cc16366.png',
    'https://oss.findinai.cn/storage/20250426/0dd46dc922f43471d1f9bedd513c28a8.png',
    'https://oss.findinai.cn/storage/20250807/35432f26de2f67ab7f6affdfcc6876e4.png',
    'https://oss.findinai.cn/storage/20250819/989c4407d285af46a27c04e9022d7e1f.png',
    'https://oss.findinai.cn/storage/20250426/ec7921e46890d0405daae8c8d56d4952.png',
  ];
  useEffect(() => {
    (async () => {
      let query = inviteCode ? `inviteCode=${inviteCode}&inviteSource=100003` : '';
      query = i ? `inviteCode=${i}&v=1&inviteSource=100005` : query;
      const { code, data } = (await fun.post<WrapResponse<{
        urllink: string
      }>>(
        api('/wechat/generateUrllink', true),
        {
          path: 'pages/home/index',
          query,
        },
      )).data;
      if (code === 0) {
        setUrl(data.urllink);
      }
    })();
  }, [inviteCode, i]);

  return (
    <div className="flex flex-col h-screen overflow-auto">
      {

        images.map((item) => (
          // eslint-disable-next-line @next/next/no-img-element
          <img key={item} className="aspect-auto w-full" src={item} alt="mobile-detect" onClick={() => {
            if (url) {
              window.location.href = url;
            }
          }} />
        ))
      }

    </div>
  )
}

export function MobileSide() {
  return (
    <Suspense fallback={<Loading mask />}>
      <MobileSideContent />
    </Suspense>
  );
}
